import React from 'react'

// component
import InputField from '../../InputField/InputField.component'

// mui
import { Paper, Grid, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

export default function CycleCountInput({ equipmentName, handleChange, prefix, handleSelectChange, expectedQty, countedQty, reason, handleRemove, errors = {} }) {

    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>

        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                <Grid container spacing={1} alignItems={'center'}>
                    <Grid item xs={12}>
                        <Typography variant='h5' >{equipmentName}</Typography>
                    </Grid>
                    <Grid item xs={4} sx={{ marginBottom: 2}}>
                        {`Expected Qty: ${expectedQty}`}
                    </Grid>
                    <Grid item xs={8}>
                        <InputField 
                            id={`${prefix}.countedQuantity`}
                            type="text"
                            placeholder='Counted Quantity'
                            onChange={handleChange}
                            value={countedQty}
                            isValid={errors['countedQuantity']}
                            fullwidth
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </Grid>)
}